import { MenuRoute, MenuTemplate } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the WorkOrder module.
 * Only static (non-parameterized) routes are listed.
 */
export const WORK_ORDER_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/work-order',
    labelKey: 'WorkOrder.list',
    icon: '/assets/tablerIcons/outline/clipboard-text.svg',
    moduleId: 30,
    groupLabelKey: 'MenuRoutes.group.workOrderViews'
  },
  {
    path: '/work-order/price-matrix',
    labelKey: 'WorkOrder.priceMatrix',
    icon: '/assets/tablerIcons/outline/table.svg',
    moduleId: 30,
    groupLabelKey: 'MenuRoutes.group.workOrderConfig'
  }
];

/**
 * Default menu template for the WorkOrder module (moduleId=30).
 * Used by `POST /api/MenuManagement/sync-from-template/30` to idempotently UPSERT
 * Menu1/Menu2 rows for a new tenant.
 */
export const WORK_ORDER_MENU_TEMPLATE: MenuTemplate = {
  moduleId: 30,
  roots: [
    {
      name: 'ORDRE',
      path: '',
      icon: '/assets/tablerIcons/outline/clipboard-text.svg',
      legacyLink: '?mod=30',
      children: [
        {
          name: 'Ordreliste',
          path: '/work-order',
          icon: '/assets/tablerIcons/outline/clipboard-text.svg'
        },
        {
          name: 'Prismatrise',
          path: '/work-order/price-matrix',
          icon: '/assets/tablerIcons/outline/table.svg'
        }
      ]
    }
  ]
};
